import * as types from './action-types.js';
import fetch from '../lib/hmac-fetch.js';
import { trackFetchError } from '../lib/analytics.js';
import { fetchError, requestID } from './action-helpers.js';
import { ADMIN_V1_URL, HEADERS_JSON } from '../strings.js';

export function doGetEquipment(data) {
  data._request = data._request || requestID();
  return (dispatch) => {
    dispatch({ type: types.GET_EQUIPMENT, data });
    return fetch(
      `${ADMIN_V1_URL}/locations/${data.location_id}/equipment`,
      {
        method: 'GET',
        headers: {
          ...HEADERS_JSON,
          'X-Request-ID': data._request,
        },
      }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw fetchError({
            response,
            data,
            message: 'Get equipment',
          });
        }
        return response.json();
      })
      .then((body) => {
        dispatch({ type: types.SUCCESS_GET_EQUIPMENT, data: body });
        return body;
      })
      .catch((err) => {
        dispatch({ type: types.ERROR_GET_EQUIPMENT, data: err });
        trackFetchError(err);
      });
  };
}

export function doGetEquipmentMinimumSpend(data) {
  data._request = data._request || requestID();
  return (dispatch) => {
    dispatch({ type: types.GET_EQUIPMENT_MINIMUM_SPEND, data });
    const monthParam = data.month ? `?month=${data.month}` : '';
    return fetch(
      `${ADMIN_V1_URL}/locations/${data.location_id}/equipment/minimum_spend${monthParam}`,
      {
        method: 'GET',
        headers: {
          ...HEADERS_JSON,
          'X-Request-ID': data._request,
        },
      }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw fetchError({
            response,
            data,
            message: 'Get equipment minimum spend',
          });
        }
        return response.json();
      })
      .then((body) => {
        dispatch({ type: types.SUCCESS_GET_EQUIPMENT_MINIMUM_SPEND, data: body });
        return body;
      })
      .catch((err) => {
        dispatch({ type: types.ERROR_GET_EQUIPMENT_MINIMUM_SPEND, data: err });
        trackFetchError(err);
      });
  };
}

export function doGetEquipmentProductList(data) {
  data._request = data._request || requestID();
  return (dispatch) => {
    dispatch({ type: types.GET_EQUIPMENT_PRODUCT_LIST, data });
    return fetch(
      `${ADMIN_V1_URL}/locations/${data.location_id}/equipment/${data.equipment_id}/product_list`,
      {
        method: 'GET',
        headers: {
          ...HEADERS_JSON,
          'X-Request-ID': data._request,
        },
      }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw fetchError({
            response,
            data,
            message: 'Get equipment product list',
          });
        }
        return response.json();
      })
      .then((body) => {
        dispatch({
          type: types.SUCCESS_GET_EQUIPMENT_PRODUCT_LIST,
          data: { equipment_id: data.equipment_id, ...body },
        });
        return body;
      })
      .catch((err) => {
        dispatch({ type: types.ERROR_GET_EQUIPMENT_PRODUCT_LIST, data: { equipment_id: data.equipment_id, error: err } });
        trackFetchError(err);
      });
  };
}
